<template>
  <v-layout wrap justify-space-between align-end v-if="hasDisease">
    <v-flex xs12 md5>
      <v-layout row align-end>
          <v-text-field :label="$t('LogBook.SystolicBloodPressure')" type="number" hide-details :value="systolicBloodPressure" @input="$emit('update:systolicBloodPressure', parseInt($event) || undefined)" />
          <v-flex><h3 class="mx-2">/</h3></v-flex>
          <v-text-field :label="$t('LogBook.DiastolicBloodPressure')" type="number" hide-details :value="diastolicBloodPressure" @input="$emit('update:diastolicBloodPressure', parseInt($event) || undefined)"/>
      </v-layout>
    </v-flex>
    <v-flex xs12 md5>
      <v-checkbox :label="$t('LogBook.ControledBloodPressure')" hide-details :value="controledBloodPressure" @change="$emit('update:controledBloodPressure', $event || false)"></v-checkbox>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    diagnosesICPC: { type: Array, default: ()=>([])},
    systolicBloodPressure: {type: Number},
    diastolicBloodPressure: {type: Number},
    controledBloodPressure: {type: Boolean, default: true}
  },
  data: ()=>({
    eligibleDiagnosis: ['T89', 'T90', 'K86', 'K87'],
  }),
  computed: {
    hasDisease() {
      for (let i = 0; i < this.eligibleDiagnosis.length; i++) {
        const targetICPC = this.eligibleDiagnosis[i]
        if (this.diagnosesICPC.includes(targetICPC)) return true
      }
      return false
    },
  },
  watch: {
    systolicBloodPressure(val){
      if(val && val >= 140){
        this.$emit('update:controledBloodPressure', false)
      }
    },
    diastolicBloodPressure(val){
      if(val && val >= 90){
        this.$emit('update:controledBloodPressure', false)
      }
    },
    diagnosesICPC(){
      if(!this.hasDisease){
        this.$emit('update:controledBloodPressure', null)
        this.$emit('update:systolicBloodPressure', null)
        this.$emit('update:diastolicBloodPressure', null)
      }
    }
  }
}
</script>

<style>
</style>